"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

require("./index.css");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var Checkbox = function Checkbox(_ref) {
  var children = _ref.children,
      id = _ref.id,
      checked = _ref.checked,
      onChange = _ref.onChange;

  var onDummyClick = function onDummyClick() {
    document.getElementById(id).click();
  };

  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "checkbox-container"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "checkbox-wrapper"
  }, /*#__PURE__*/_react["default"].createElement("input", {
    type: "checkbox",
    id: id,
    checked: checked,
    className: "real-checkbox",
    onChange: onChange
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: "dummy-checkbox",
    onClick: onDummyClick
  })), /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("label", {
    htmlFor: id
  }, children)));
};

var _default = Checkbox;
exports["default"] = _default;